// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateAccessTokenMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  name: Types.Scalars["String"]["input"];
  scopes:
    | Array<Types.Scalars["String"]["input"]>
    | Types.Scalars["String"]["input"];
  expiresInDays?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type CreateAccessTokenMutation = {
  __typename?: "Mutation";
  createAccessToken: {
    __typename?: "CreateAccessTokenPayload";
    token: string;
    accessToken: {
      __typename?: "AccessToken";
      id: string;
      name: string;
      tokenPrefix: string;
    };
  };
};

export type RevokeAccessTokenMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type RevokeAccessTokenMutation = {
  __typename?: "Mutation";
  revokeAccessToken: {
    __typename?: "RevokeAccessTokenPayload";
    success: boolean;
  };
};

export const CreateAccessTokenDocument = gql`
  mutation CreateAccessToken(
    $organizationSlug: ID!
    $name: String!
    $scopes: [String!]!
    $expiresInDays: Int
  ) {
    createAccessToken(
      organizationSlug: $organizationSlug
      name: $name
      scopes: $scopes
      expiresInDays: $expiresInDays
    ) {
      token
      accessToken {
        id
        name
        tokenPrefix
      }
    }
  }
`;
export type CreateAccessTokenMutationFn = Apollo.MutationFunction<
  CreateAccessTokenMutation,
  CreateAccessTokenMutationVariables
>;

/**
 * __useCreateAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessTokenMutation, { data, loading, error }] = useCreateAccessTokenMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      name: // value for 'name'
 *      scopes: // value for 'scopes'
 *      expiresInDays: // value for 'expiresInDays'
 *   },
 * });
 */
export function useCreateAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAccessTokenMutation,
    CreateAccessTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAccessTokenMutation,
    CreateAccessTokenMutationVariables
  >(CreateAccessTokenDocument, options);
}
export type CreateAccessTokenMutationHookResult = ReturnType<
  typeof useCreateAccessTokenMutation
>;
export type CreateAccessTokenMutationResult =
  Apollo.MutationResult<CreateAccessTokenMutation>;
export type CreateAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateAccessTokenMutation,
  CreateAccessTokenMutationVariables
>;
export const RevokeAccessTokenDocument = gql`
  mutation RevokeAccessToken($id: ID!) {
    revokeAccessToken(id: $id) {
      success
    }
  }
`;
export type RevokeAccessTokenMutationFn = Apollo.MutationFunction<
  RevokeAccessTokenMutation,
  RevokeAccessTokenMutationVariables
>;

/**
 * __useRevokeAccessTokenMutation__
 *
 * To run a mutation, you first call `useRevokeAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAccessTokenMutation, { data, loading, error }] = useRevokeAccessTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeAccessTokenMutation,
    RevokeAccessTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeAccessTokenMutation,
    RevokeAccessTokenMutationVariables
  >(RevokeAccessTokenDocument, options);
}
export type RevokeAccessTokenMutationHookResult = ReturnType<
  typeof useRevokeAccessTokenMutation
>;
export type RevokeAccessTokenMutationResult =
  Apollo.MutationResult<RevokeAccessTokenMutation>;
export type RevokeAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  RevokeAccessTokenMutation,
  RevokeAccessTokenMutationVariables
>;
